import React, { useState, useEffect } from "react";
import TranscriptionMain from "./008q/TranscriptionMain"; // Componente hijo
import CdrService from "../../services/v2/cdr-service";

const CdrCallRecording = ({ id }) => {
  const [callRecording, setCallRecording] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) {
      return; // No hacemos nada si no hay ID
    }

    const fetchRecording = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await CdrService.callRecording(id);
        setCallRecording(response.data); // Guardamos el stream del audio
      } catch (err) {
        setError(
          "Some error occurred while trying to fetch the call recording."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchRecording();
  }, [id]);

  // Si no se recibió un ID, mostramos un badge amarillo
  if (!id) {
    return (
      <div className="flex items-center justify-center h-full w-full">
        <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg shadow-md">
          No call recording found for this call.
        </div>
      </div>
    );
  }

  // Si hubo un error, mostramos un badge rojo
  if (error) {
    return (
      <div className="flex items-center justify-center h-full w-full">
        <div className="bg-red-100 text-red-800 px-4 py-2 rounded-lg shadow-md">
          {error}
        </div>
      </div>
    );
  }

  // Si estamos cargando, mostramos un badge azul de carga
  if (loading) {
    return (
      <div className="flex items-center justify-center h-full w-full">
        <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg shadow-md">
          Loading call recording...
        </div>
      </div>
    );
  }

  // Si tenemos el stream del audio, renderizamos el componente hijo
  if (callRecording) {
    return (
      <div className="flex items-center justify-center h-full w-full">
        <TranscriptionMain id={id} callRecording={callRecording} />
      </div>
    );
  }

  return null; // Si no hay nada que renderizar, devolvemos null
};

export default CdrCallRecording;
